import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TaskTemplateListView from 'src/pages/admin/templates/tasks/task-template-list';
import { ApplicationState } from "../../../../stores/reducers";
import { refreshTableTaskToggle } from "../../../../stores/actions/taskTemplate";


export const WrapperTaskTemplateTable = (props: any) => {
    const dispatch = useDispatch();
    const handleRefreshTable = (value: boolean) => {
        dispatch(refreshTableTaskToggle(value));
    };

    const isRefreshTable = useSelector((state: ApplicationState) => state.taskTemplate.refreshTablet);

    return <TaskTemplateListView
        handleResetTableSuccess={handleRefreshTable}
        isRefreshTable={isRefreshTable}
        {...props}
    />
}